import React, { useLayoutEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Col, Row } from 'reactstrap';
import { EXPENSE_SAP_MIGRATION_PATH } from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import { tzNormalizeDate } from '../../../../utils/date';
import { DATE_FORMAT } from '../../../../config/locale';
import {
  clearExpensesSapMigration,
  getExpensesSapMigration,
  putExpenseSapMigration,
} from '../../../../actions';
import ExpenseSapMigrationSearchForm from './ExpenseSapMigrationSearchForm';
import ExpenseSapMigrationTableForm from './ExpenseSapMigrationTableForm';

export const ExpenseSapMigrations = ({
  breadcrumbs,
  loading,
  dispatchPutExpenseSapMigration,
  dispatchClearExpensesSapMigration,
}) => {

  const [query, setQuery] = useState('');
  const [searchToken, setSearchToken] = useState('');

  useLayoutEffect(
    () => () => {
      dispatchClearExpensesSapMigration();
    },
    [],
  );

  const onHandleSearch = (formValues) => {
    const fromDate = tzNormalizeDate({ date: formValues.fromDateString, format: DATE_FORMAT });
    const toDate = tzNormalizeDate({ date: formValues.toDateString, format: DATE_FORMAT });

    setQuery(`createDate$${fromDate},${toDate}`);
    setSearchToken((prev) => prev + 1);
  };

  const content = (
    <>
      <Row className="justify-content-end">
        <Col xs={12} className="mb-3">
          <ExpenseSapMigrationSearchForm
            onSubmit={onHandleSearch}
            initialValues={{
              fromDateString: tzNormalizeDate(),
              toDateString: tzNormalizeDate(),
            }}
            loading={loading}
          />
        </Col>
      </Row>

      <div className="mt-5">
        <ExpenseSapMigrationTableForm
          dispatchPutExpenseSapMigration={dispatchPutExpenseSapMigration}
          query={query}
          searchToken={searchToken}
        />
      </div>
    </>
  );

  return (
    <Content
      title="Egresos a SAP"
      breadcrumbs={breadcrumbs}
      content={content}
    />
  );
};

const mapStateToProps = ({ AccountingUnit }) => ({
  breadcrumbs: [
    ...AccountingUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Egresos a SAP',
      href: EXPENSE_SAP_MIGRATION_PATH,
    },
  ],
  loading: AccountingUnit.ExpenseSapMigration.getIn(['all', 'loading']),
});

const mapDispatchToProps = {
  dispatchGetExpensesSapMigration: getExpensesSapMigration,
  dispatchPutExpenseSapMigration: putExpenseSapMigration,
  dispatchClearExpensesSapMigration: clearExpensesSapMigration,
};

ExpenseSapMigrations.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  loading: PropTypes.bool,
  dispatchPutExpenseSapMigration: PropTypes.func.isRequired,
  dispatchClearExpensesSapMigration: PropTypes.func.isRequired,
};

ExpenseSapMigrations.defaultProps = {
  loading: false,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExpenseSapMigrations);
